<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import author from "./author.js";
import { mapActions } from "vuex";

export default {
  name: 'App',
  methods:{
    ...mapActions([
      "getDefaultInfo",
      "getCommerceInfo"
    ]),
  },
  beforeCreate(){
    // localStorage.clear();
    if(this.$route.query.shid){
      localStorage.setItem('shid', this.$route.query.shid);
    } else if(window.location.search) {
      const search = window.location.search.match(/shid=([a-z0-9-]*)/);
      const shid = search&&search.length?search[1]:'';
      localStorage.setItem('shid', shid);
      window.location.href = '/userinfo/#/login?shid='+shid;
    }
  },
  created(){
    this.getDefaultInfo();
    this.getCommerceInfo();
  },
  mounted(){
    const shid = this.$route.query.shid;
    const local_shid = localStorage.getItem('shid');
    if(!shid&&!local_shid) {
      this.$message.error({
        message: '缺少商会标识信息，请联系管理员确认访问地址是否正确。',
        duration: 0,
        showClose: true
      });
    } else if (shid&&!local_shid){
      localStorage.setItem('shid', shid);
    }
    author({
      type: 1
    }, this.$router);
  }
}
</script>

<style lang="less">
@import "./src/assets/css/main.less";
</style>

